(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('agendaLabelFilter', ['$filter', 'AgendaFilterBroadcast', AgendaLabelFilterFn]);

    // filter directive for multiple agenda filter selection
    function AgendaLabelFilterFn($filter, AgendaFilterBroadcast) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-label-filter.template.html',
            scope: {
                agendaLabels: '=',
                paginationService: '='
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // broadcast listener
            var listener = null;
            var listenerCalc = null;
            var listenerClear = null;

            // number of set filter
            scope.numFilters = 0;

            //activate directive
            activate();

            // filter list
            scope.filter = function (label) {
                //reset
                scope.numFilters = 0;

                // role change
                if (label !== null) {
                    label.vmSelected = !label.vmSelected;
                }

                // refresh view
                refresh();
            };

            // destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }

                if (listenerCalc) {
                    listenerCalc();
                    listenerCalc = null;
                }

                if (listenerClear) {
                    listenerClear();
                    listenerClear = null;
                }
            });

            // calc numbers of appointments with labels
            function calculate() {
                clear();

                // number of appointments in defined types
                for (var j = 0; j < scope.paginationService.data.items.length; j++) {
                    var appointmentsPerDay = scope.paginationService.data.items[j].appointmentsPerDay;
                    // convert object (dictionary with list as value) to array
                    for (var date in appointmentsPerDay) {
                        if (appointmentsPerDay.hasOwnProperty(date)) {
                            var appointmentList = appointmentsPerDay[date];
                            for (var m = 0; m < appointmentList.length; m++) {
                                var state = $filter('filter')(scope.agendaLabels, { 'id': appointmentList[m].agendaLabelId }, true)[0];
                                if (state) {
                                    state.vmNumber++;
                                } //if
                            }
                        } //if
                    } // for
                } //for
            } // calculate

            // clear badge counts
            function clear() {
                //reset badge numbers
                for (var i = 0; i < scope.agendaLabels.length; i++) {
                    scope.agendaLabels[i].vmNumber = 0;
                } // for
            }

            // refresh view
            function refresh() {
                // number of selected states
                scope.numFilters = 0;
                for (var i = 0; i < scope.agendaLabels.length; i++) {
                    if (scope.agendaLabels[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // listen
            function listen() {
                //check for doing a refresh
                listener = scope.$on(AgendaFilterBroadcast.AgendaLabelRefresh, function () {
                    refresh();
                });

                listenerCalc = scope.$on(AgendaFilterBroadcast.AgendaLabelCalculate, function () {
                    calculate();
                });

                listenerClear = scope.$on(AgendaFilterBroadcast.AgendaLabelClear, function () {
                    clear();
                });
            } // listen

            // init work
            function activate() {
                // calculate badge count
                calculate();

                // refresh view
                refresh();

                // listen
                listen();
            } //activate
        } // link
    }
})();